<template>
  <div class="row mt-4">
    <div class="col-2">
      <font-awesome-icon :icon="['fas', 'users']" class="ml-1 icon" />
      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.total') }}
      </span>
      <span class="ml-3 total-number">
        <animated-number :value="summary.total" :formatValue="formatToPrice" :duration="500" /></span>
    </div>
    <div class="col-2 box" @click="setFilter('respondido')">
      <font-awesome-icon :icon="['fas', 'clipboard-check']" class="ml-1 icon answered-icon" />
      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.answered') }}
      </span>
      <span class="ml-3 overview">
        {{ summary.answered || 0 }} - {{ getPercentage(summary.answered) }}%
      </span>
    </div>
    <div class="col-2 box" @click="setFilter('aberto')">
      <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="ml-1 icon opened-icon" />
      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.opened') }}
      </span>
      <span class="ml-3 overview">
        {{ summary.opened || 0 }} - {{ getPercentage(summary.opened) }}%
      </span>
    </div>
    <div class="col-2 box" @click="setFilter('escalonada')">
      <font-awesome-icon :icon="['fas', 'exchange-alt']" class="ml-1 icon staggered-icon" />
      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.staggered') }}
      </span>
      <span class="ml-3 overview">
        {{ summary.transfered || 0 }} - {{ getPercentage(summary.transfered) }}%
      </span>
    </div>
    <div class="col-2 box" @click="setFilter('em_analise')">
      <font-awesome-icon :icon="['fas', 'search-plus']" class="ml-1 icon analysis-icon" />
      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.analysis') }}
      </span>
      <span class="ml-3 overview">
        {{ summary.analysis || 0 }} - {{ getPercentage(summary.analysis) }}%
      </span>
    </div>

    <!--OUTROS-->
    <div class="col-2">

      <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ml-1 icon other-icon" />

      <span class="ml-3 status-text idx-bold">
        {{ $t('treatments.overview.others') }}
      </span>
      <span class="ml-3 overview">
        {{ summary.total - summary.answered - summary.opened - summary.transfered - summary.analysis || 0 }} - {{
          getPercentage(summary.total - summary.answered - summary.opened - summary.transfered - summary.analysis) }}%
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AnimatedNumber from 'animated-number-vue';
import EventBus from '../../../eventBus';

export default {
  components: {
    AnimatedNumber,
  },

  computed: {
    ...mapState('treatments', ['summary']),
  },

  methods: {

    setFilter(status) {
      this.filterActive = status;
      EventBus.$emit('filter-status', status)
    },

    formatToPrice(value) {
      return value.toFixed(0);
    },

    getPercentage(value) {
      const percentage = (value / this.summary.total) * 100;

      if (isNaN(percentage)) {
        return 0;
      }

      return percentage.toFixed(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.box{
  cursor: pointer;
}
.row {
  .col-2 {
    height: 80px;
    border-right: 1px solid #ccc;
    &:last-child {
      border-right: 0;
    }
  }
}

.icon {
  font-size: 30px;
  margin-top: 10px;
}

.answered-icon {
  color: #28a745;
}

.other-icon {
  color: gray
}

.opened-icon {
  color: #dc3545;
}

.staggered-icon {
  color: #ffc107;
}

.analysis-icon {
  color: #72bcd4;
}

.status-text {
  position: absolute;
  top: 0;
}

.total-number {
  position: absolute;
  top: 20px;
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatment-overview/index.vue